import React from 'react';
// eslint-disable-next-line import/no-named-as-default
import VinEditor from '../views/pairing/editor/VinEditor';
import CarMaxZoneInput from '../views/kmxZone/CarMaxZoneInput';
import CarMaxZoneInputValidator from '../views/kmxZone/CarMaxZoneInputValidator';
import ZoneEnvironmentEditor from './ZoneEnvironmentEditor';
import NoneEditor from './NoneEditor';
import KeySetup from './key/PluginSetup';
import ContractSetup from './contract/PluginSetup';
export default {
  install(molten) {
    molten.addPlugin('AttributeValueEditor', {
      name: 'name',
      objectType: 'vehicle',
      getOptions: usage => {
        return {
          embed: true,
          isRenderer: false
        };
      },
      create: opts => /*#__PURE__*/React.createElement(VinEditor, opts)
    });
    molten.addPlugin('AttributeValueEditor', {
      name: 'environment',
      objectType: 'zone',
      getOptions: usage => {
        return {
          embed: true,
          isRenderer: false
        };
      },
      create: opts => /*#__PURE__*/React.createElement(ZoneEnvironmentEditor, opts)
    });
    molten.addPlugin('BlueprintAttributeFormEditor', {
      type: 'none',
      editor: NoneEditor
    });
    molten.addPlugin('AttributeValueEditor', {
      name: 'kmx/name',
      objectType: 'zone',
      getOptions: usage => {
        return {
          embed: true,
          isRenderer: false
        };
      },
      create: opts => /*#__PURE__*/React.createElement(CarMaxZoneInput, opts)
    });
    molten.addPlugin('AttributeValueValidator', {
      name: 'kmx/name',
      objectType: 'zone',
      valueValidator: CarMaxZoneInputValidator
    });
    KeySetup.install(molten);
    ContractSetup.install(molten);
  }
};